/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of SourceTransactionsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import { SuccessResponse_1OfGetSourceTransactionsResponse } from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockSourceTransactions = [
  {
    id: 1,
    sourceTransactionID: 'TXN001',
    storeNumber: 'STORE001',
    transactionDate: '2025-12-12',
    itemNumber: 'ITEM001',
    quantity: 10,
    transactionType: 'Sale',
    source: 'POS',
  },
  {
    id: 2,
    sourceTransactionID: 'TXN002',
    storeNumber: 'STORE001',
    transactionDate: '2025-12-12',
    itemNumber: 'ITEM002',
    quantity: 5,
    transactionType: 'Sale',
    source: 'POS',
  },
  {
    id: 3,
    sourceTransactionID: 'TXN003',
    storeNumber: 'STORE001',
    transactionDate: '2025-12-12',
    itemNumber: 'ITEM001',
    quantity: 24,
    transactionType: 'Receipt',
    source: 'PO',
  },
];

/* ---- Mocked Client Implementation ---- */

import { ISourceTransactionsClient } from '../../interfaces';
export class SourceTransactionsClientMocked implements ISourceTransactionsClient {
  constructor(baseUrl?: string) {}

  async sourcetransactions(
    store: string,
    sourceTransactionID: string,
    transactionDate: string,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfGetSourceTransactionsResponse> {
    await delay();
    const transactions = mockSourceTransactions.filter(
      (t) =>
        t.storeNumber === store &&
        t.sourceTransactionID === sourceTransactionID &&
        t.transactionDate === transactionDate
    );
    return successResponse({
      sourceTransactions: transactions,
      totalCount: transactions.length,
    }) as SuccessResponse_1OfGetSourceTransactionsResponse;
  }

  // ====== Auto-generated stub methods ======




  // ====== Auto-generated stub methods ======









}
